import { Button, Col, Link, Row } from 'atoms'
import { isPresent } from 'lib/utils'
import Image from 'next/image'
import { FC, ReactNode } from 'react'
import { HiChevronDoubleRight } from 'react-icons/hi'
import { IoIosTimer } from 'react-icons/io'

import Styles from './Course.module.sass'

import type { Course as ICourse } from './courses'

interface CourseProps {
  course: ICourse,
}

const Course: FC<CourseProps> = ({ course }) => (
  <CourseWrapper course={course}>
    <Row className='flex-row-reverse align-items-start'>
      <Col xs={12} sm={4} md={3} lg={2}>
        <Image
          src={course.image}
          alt={course.title}
          objectFit="cover"
          placeholder="blur"
          className="image"
        />
      </Col>
      <Col xs={12} sm={8} md={9} lg={10} className="content">
        <h2>{course.title}</h2>
        <p className="summary">
          {course.summary}
        </p>
        {course.topics && (
          <ul className="topics">
            {course.topics.map((topic, i) => (
              <li key={i}>
                {topic}
              </li>
            ))}
          </ul>
        )}
        {course.released && (
          <Button
            rel="noreferrer"
            target="_blank"
            href={course.url || '#'}
            theme='green'
          >
            Mehr erfahren&nbsp;<HiChevronDoubleRight />
          </Button>
        )}
      </Col>
    </Row>
    {!course.released && (
      <div className="soonAvailable">
        <p>
          <IoIosTimer />&nbsp;Bald verfügbar...
        </p>
      </div>
    )}
  </CourseWrapper>
)

interface CourseWrapperProps extends CourseProps {
  children?: ReactNode;
}

const CourseWrapper: FC<CourseWrapperProps> = ({ children, course: {
  released,
  title,
  url,
} }) => released && isPresent(url) ? (
  <Link
    // external
    title={title}
    // rel="noreferrer"
    href={url || '#'}
    className={Styles.container}
  >
    {children}
  </Link>
) : (
  <div className={`${Styles.container} ${Styles.containerDisabled}`}>
    {children}
  </div>
)

export default Course
